import { NgModule } from '@angular/core';
import { NgCustomBlocklyService } from './ng-custom-blockly.service';

@NgModule({
  imports: [
  ],
  exports: [
  ],
  providers: [
    NgCustomBlocklyService
  ]
})
export class NgCustomBlocklyModule {
  constructor(private ngBlockly: NgCustomBlocklyService) {
    this.ngBlockly.initCustomField();
  }
}
